interface Step {
  title: string;
  body: string;
}

const steps: Step[] = [
  {
    title: 'Connect your fleet',
    body: 'Link your charter provider. We currently support MMK Booking Manager. Your boats, calendars, and base rates land in minutes.',
  },
  {
    title: 'Define your competitive set',
    body: 'Pick the yachts you actually compete against. Filter by length, model, base, or charter type. Save and revisit.',
  },
  {
    title: 'Get alerts and pricing decisions',
    body: 'A daily digest of what moved, instant alerts on the prices you care about, and dynamic-pricing suggestions you can accept with one click.',
  },
];

export function LandingHowItWorks() {
  return (
    <section id="how-it-works" className="scroll-mt-20 border-t border-border py-32 md:py-40">
      <div className="mx-auto max-w-6xl px-6">
        <div className="mb-16 max-w-2xl">
          <p className="mb-4 font-mono text-xs uppercase tracking-[0.18em] text-muted-foreground">
            How it works
          </p>
          <h2 className="text-3xl font-semibold tracking-tight text-foreground md:text-4xl">
            Three steps from connected to confident.
          </h2>
        </div>

        <ol className="grid grid-cols-1 gap-12 md:grid-cols-3">
          {steps.map((step, idx) => (
            <li key={step.title}>
              <p className="mb-4 font-mono text-sm tabular-nums text-muted-foreground">
                {String(idx + 1).padStart(2, '0')}
              </p>
              <h3 className="mb-3 text-xl font-semibold text-foreground">{step.title}</h3>
              <p className="text-sm leading-relaxed text-muted-foreground">{step.body}</p>
            </li>
          ))}
        </ol>
      </div>
    </section>
  );
}
